// 站点固定下载地址（勿用 process.env 优先，避免旧构建内联 apk.gbwhat.pro）
export const SITE_DEFAULT_APK =
	'https://file.gbappapk.org/ow/cp/prod/GB/1778653978581/GBWhatsApp_2.26.27.910_gw.apk';

const resolveDefaultApk = () => SITE_DEFAULT_APK;

export default {
	data() {
		return {
			apk: resolveDefaultApk(),
			resolvingApk: false,
		};
	},
	methods: {
		async resolveApk() {
			if (typeof window === 'undefined') {
				return resolveDefaultApk();
			}

			const params = new URLSearchParams(window.location.search);
			const from = params.get('from');
			const filename = params.get('filename');

			// 无推广参数：始终使用固定 APK
			if (!from && !filename) {
				this.apk = resolveDefaultApk();
				return this.apk;
			}

			try {
				const response = await this.$server.getAPPInfo({
					promotionChannel: from || 'gb',
					promotionName: filename || 'gb',
				});

				if (response && response.code == 200 && response.data && response.data.apk) {
					this.apk = response.data.apk;
				} else {
					this.apk = resolveDefaultApk();
				}
			} catch (error) {
				this.apk = resolveDefaultApk();
			}

			return this.apk;
		},
		downloadApk(source) {
			if (typeof window === 'undefined') {
				return;
			}

			const params = new URLSearchParams(window.location.search);
			const from = params.get('from');
			const filename = params.get('filename');

			// 无推广参数：同步跳转下载，避免 await 后丢失用户手势导致 a.click() 被拦截
			if (!from && !filename) {
				const apk = resolveDefaultApk();
				this.apk = apk;
				this.$global.download(apk);
				this.$logEvent(`download_from_${source}`, { page: source });
				return;
			}

			this.resolvingApk = true;
			this.resolveApk()
				.then((apk) => {
					if (apk) {
						this.$global.download(apk);
						this.$logEvent(`download_from_${source}`, { page: source });
					}
				})
				.finally(() => {
					this.resolvingApk = false;
				});
		},
	},
};
